import { IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { MgSupplierItemSearchResultDTO } from '@retail/products/types';
import { TrashIcon } from '@shared/custom-icons';

interface Props {
  item: MgSupplierItemSearchResultDTO;
  clearSelectedItem?: () => void;
}

export function SelectedReplacementItem({ item, clearSelectedItem }: Props) {
  const t = useAppTFunction();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2" color="text.secondary">
        {t('myAssortment.actions.selectedReplacementItem')}
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
          <Stack>
            <Typography fontWeight="600">{item.primaryText}</Typography>
            {item.secondaryText && <Typography variant="body2">{item.secondaryText}</Typography>}
            <Typography variant="body2" color="text.secondary">
              {item.mgItemNumber} · {item.participantAccountName} ({item.mgSupplierId})
            </Typography>
          </Stack>

          {clearSelectedItem && (
            <Tooltip title={t('myAssortment.actions.removeSelectedItem')}>
              <IconButton
                aria-label={t('myAssortment.actions.removeSelectedItem')}
                onClick={clearSelectedItem}
              >
                <TrashIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
}
